const vtoEvents = {
  "vto.view": ({ sku }) => ({
    eventAction: "Available",
    eventLabel: `Product ${sku} - Available`,
    VTO: {
      configFlow: {
        action: "view step",
        name: "vto available",
        id: "000"
      }
    }
  }),
  "vto.tryon.open": ({ sku }) => ({
    eventAction: "Open",
    eventLabel: `Product ${sku}`,
    VTO: {
      configFlow: {
        action: "click",
        name: "open vto"
      }
    }
  }),
  "vto.close": ({ sku }) => ({
    eventAction: "Close",
    eventLabel: `Product ${sku}`,
    VTO: {
      configFlow: {
        action: "click",
        name: "close vto"
      }
    }
  })
};
const vtoEvent = (key, args) => {
  if (!vtoEvents[key]) {
    console.warn(`cannot send event '${key}', key does not exist`);
    return;
  }
  const { eventAction, eventLabel, VTO } = vtoEvents[key](args);
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "VTOevent",
      eventCategory: "Virtual Try-On",
      eventAction,
      eventLabel,
      VTO
    });
  }
};
export {
  vtoEvent
};
//# sourceMappingURL=vto-event.js.map
